

const TableDropdown = (props) => {
    const options = props.options
    const dropdown = props.dropdown
    const update = props.update
    const handleClick = (id) => {
        update(id, dropdown)
    }

    return(
        <div className="table-dropdown-container">
            {options && options.map((option, idx) => {
                return (
                    <div className={idx === 0 ? "table-dropdown-row first link":"table-dropdown-row link"} id={idx} onClick={() => handleClick(option)}>
                        {option.name}
                    </div>
                )
            })}
        </div>
        )
}

export default TableDropdown